import React, { useMemo } from 'react';
import { useGetPartners } from 'src/pages/partnership/api/queries';
import { Partner, PartnerCategory } from 'src/pages/partnership/types';
import Partners from './partners';

export default function PartnersWrapper() {
  const { data: partnerCategories = [] } = useGetPartners({ tagId: undefined });

  const partners = useMemo(
    () => partnerCategories.reduce((i: Partner[], ar: PartnerCategory) => i.concat(ar.partners ?? []), []).slice(0, 9),
    [partnerCategories]
  );
  return <Partners items={partners} />;
}
